import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex)

const state = {
  activityID: '', // 活动名称
  isInIos: false,
  isLogin: false,
  isOutSide: false,
  userInfo: {},
  statusBarHeight: 0,
  appVersion: 0,
  channel: '', // 渠道
  h5ConfigDetails: null,
  h5ConfigImgPath: '',
  productList: [], // 产品列表
  couponList: [], // 礼包列表
  taskList: [], // 任务列表
  couponsHistory: null, // 用户礼包历史数据
  activityConfig: {}, //模板配置信息
  shareInTaskId: null, // 分享后做任务id
  shareInCouponId: null, // 分享后领取礼包id
  bindRoleInfo: null, // livelink绑定角色信息
  llkSwitchOn: false, // livelink portal 开关
  hasClickLotteryBtn: false, // 是否点击过抽奖按钮
  hasClickBottomBuyBtn: false, // 是否点击过立即购买按钮
  hasFinishPayAction: false // 是否完成过支付动作
}

export default new Vuex.Store({
  state,
  mutations,
  getters
})
